module.exports = __webpack_public_path__ + "img/img92.675a2795.png";